import FormikField from "./Forms/FormikField"
import TextField from "./Forms/FieldTypes/TextField"

function MentorFields({ firstNameRef }) {
  return (
    <div className="mb-2 mt-4 flex flex-col items-center gap-3 md:flex-row">
      <FormikField name="first_name" title="First name" containerClassName="mb-4 md:mb-0 w-full">
        <TextField
          name="first_name"
          placeholder="Mentor's first name"
          type="text"
          className="mx-auto w-full max-w-72"
          innerRef={firstNameRef}
        />
      </FormikField>
      <FormikField name="last_name" title="Last name" containerClassName="mb-4 md:mb-0 w-full">
        <TextField
          name="last_name"
          placeholder="Mentor's last name"
          type="text"
          className="mx-auto max-w-72"
        />
      </FormikField>
      <FormikField name="email" title="Email address (optional)" containerClassName="mb-4 md:mb-0 w-full">
        <TextField
          name="email"
          placeholder="Mentor's email (optional)"
          type="email"
          className="mx-auto max-w-72"
        />
      </FormikField>
    </div>
  )
}

export default MentorFields
